import React, { Fragment, useState } from "react";

import { Row, Col } from "../UI/Customstrap/Customstrap";

import style from "./PageWrapper.scss";

export const PageWrapper = ({ title, children }) => (
  <Row>
    <Col>
      <Row>
        <Col className={style.titleWrapper}>
          <span className={style.title}>{title}</span>
        </Col>
      </Row>
      <Row>
        <Col>{children}</Col>
      </Row>
    </Col>
  </Row>
);
